module.exports = __webpack_public_path__ + "img/digitaldoc.206c94c8.png";